<lib-dialog-layout>
    <ng-container title>
        @if (isBookFromCalendar && !hasOpenLessonSlots) {
            <ng-container i18n="@@TPConfigurationNoLessonSlotsDialogTitle">No Open #Lessons# Available</ng-container>
        } @else {
            <ng-container i18n="@@TPConfigurationErrorDialogTitle">Configuration Error</ng-container>
        }
    </ng-container>

    <ng-container content>
        @if (isMultiTeacherSchool) {
            @if (isBookFromAvail) {
                <div class="d-flex flex-column gap-2">
                    <p
                        class="typography-body-medium"
                        i18n="@@TPConfigurationMultiTeacherErrorDialogText">
                        No #teachers# are currently available for public booking. To enable booking, at least one #teacher# must:
                    </p>
                    <p class="padding-left-24 typography-body-medium">
                        <li i18n="@@TPConfigurationMultiTeacherErrorDialogTextPointOne">Be marked as visible on public forms</li>
                        <li i18n="@@TPConfigurationMultiTeacherErrorDialogTextPointTwo">Have recorded availability with "Allow Online Booking" enabled</li>
                    </p>
                </div>
            } @else if (isBookFromCalendar) {
                @if (!hasOpenLessonSlots) {
                    <div class="d-flex flex-column gap-2">
                        <p
                            class="typography-body-medium"
                            i18n="@@TPConfigurationMultiTeacherNoOpenLessonErrorDialogText">
                            The widget cannot display any available #lessons# for booking because the #teachers# included in this form do not have any upcoming open
                            lessons scheduled on the calendar. Add an open #lesson# to the calendar to allow users to book using this form.
                        </p>
                    </div>
                } @else {
                    <div class="d-flex flex-column gap-2">
                        <p
                            class="typography-body-medium"
                            i18n="@@TPConfigurationMultiTeacherNoPublicBookingErrorDialogText">
                            No #teachers# are currently available for public booking. To enable booking, at least one #teacher# must be marked as visible on public
                            forms.
                        </p>
                    </div>
                }
            }
        } @else {
            @if (isBookFromAvail) {
                <p
                    class="typography-body-medium"
                    i18n="@@TPConfigurationSingleTeacherAvailabilityBookingErrorDialogText">
                    You are currently not available for online booking. To enable online booking, you must have recorded an availability with "Allow Online Booking"
                    enabled.
                </p>
            } @else if (isBookFromCalendar && !hasOpenLessonSlots) {
                <p
                    class="typography-body-medium"
                    i18n="@@TPConfigurationSingleTeacherNoOpenErrorDialogText">
                    The widget cannot display any available #lessons# for booking because you do not have any upcoming open #lessons# scheduled on the calendar.
                    <br />
                    Add an open #lesson# to the calendar to allow users to book using this form.
                </p>
            }
        }
    </ng-container>
    <ng-container submissionBar>
        <lib-submission-bar [kind]="SubmissionBarKind.DialogBasic">
            @if (isBookFromCalendar && !hasOpenLessonSlots) {
                <lib-button
                [role]="ButtonRole.Primary"
                    [loading]="primaryActionClicked"
                    (clicked)="GoToCalendar()">
                    <ng-container
                        label
                        i18n="@@TPConfigurationDialogGoToCalendarButton">
                        Go To Calendar
                    </ng-container>
                </lib-button>
            } @else if (isMultiTeacherSchool) {
                @if (canRouteToTeachers) {
                    <lib-button
                    [role]="ButtonRole.Primary"
                        [loading]="primaryActionClicked"
                        (clicked)="GoToTeachers()">
                        <ng-container
                            label
                            i18n="@@TPConfigurationDialogReviewTeachersButton">
                            Review #Teachers#
                        </ng-container>
                    </lib-button>
                }
            } @else {
                <lib-button
                [role]="ButtonRole.Primary"
                    [loading]="primaryActionClicked"
                    (clicked)="GoToAvailability()">
                    <ng-container
                        label
                        i18n="@@TPConfigurationDialogReviewAvailabilityButton">
                        Review Availability
                    </ng-container>
                </lib-button>
            }
            <lib-button
            [role]="ButtonRole.Secondary"
                [kind]="ButtonKind.NeutralSecondary"
                [disabled]="primaryActionClicked"
                (clicked)="DismissAction()">
                <ng-container
                    label
                    i18n="@@CommonCloseButton">
                    Close
                </ng-container>
            </lib-button>
            <lib-button
            [role]="ButtonRole.Tertiary"
                [kind]="ButtonKind.Secondary"
                [disabled]="primaryActionClicked"
                (clicked)="HelpArticleClicked()">
                <ng-container
                    label
                    i18n="@@TPConfigurationDialogHelpArticleButton">
                    Help Article
                </ng-container>
            </lib-button>
        </lib-submission-bar>
    </ng-container>
</lib-dialog-layout>
